<template>
  <div class="jin-pc-list jin-pc">
    <div class="jin-pc-container jin-list-con">
      <ZpProcess v-show="$route.query.attributes==='0'" />
      <div class="jin-list-position-warp">
        <Category :category="category" :active="active" @change="onChange" />
        <List ref="list" :show-page="true" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ZpProcess from '@/components/ZpProcess'
import myMixin from '@/minxin/list'

export default {
  components: {
    ZpProcess
  },
  mixins: [myMixin],
  data() {
    return {
      active: '全部职位'
    }
  },
  methods: {
    ...mapMutations('position', ['SET_CATEGORY_TITLE', 'SET_KEY_WORDS']),
    onChange(item) {
      this.SET_KEY_WORDS('')
      this.active = item.name
      this.SET_CATEGORY_TITLE({ name: item.name, id: item.id })
      this.$refs.list && this.$refs.list.handlePcList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/page/list-pc.scss'
</style>
